import { render } from "./OrderDrawer.vue?vue&type=template&id=6c06b3dc&scoped=true"
import script from "./OrderDrawer.vue?vue&type=script&lang=js"
export * from "./OrderDrawer.vue?vue&type=script&lang=js"

import "./OrderDrawer.vue?vue&type=style&index=0&id=6c06b3dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c06b3dc"]])

export default __exports__